// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"ed2dc5bd","73":"b595c74d","86":"287fcf2b","213":"38cbda13","239":"b19b3090","308":"96590afc","454":"c256853b","455":"9ad3d77d","487":"36f742cb","503":"a301b1b1","642":"0af54279","690":"5e384cdd","742":"8f6655fb","770":"595648a4","794":"b58e16a0","974":"21f96b74"}[chunkId] + ".chunk.js";
};